// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getIconPath } from '@tcp/core/src/utils';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel';
import styles from '../styles/AddressCarousel.style';
import AddressCard from './AddressCard';
import AddNewAddress from './AddNewAddress';
import ADDRESS_CAROUSEL_CONSTANTS from './AddressCarousel.constants';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../../../../../../utils/labels/labelUtilty';
import ShippingPageLabels, { ADDRESS_LABELS } from '../../../../../../views/ShippingPage.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblEdit,
} from '../../../../../../../../../../../../utils/labels/globalActions.labels';

export const AddressCarousel = (props) => {
  const addressSectionLabels = getLabelFromCopyOrFromTranslation(
    ADDRESS_LABELS,
    ShippingPageLabels
  );
  const {
    className,
    addresses,
    disableEdit,
    selectedValue,
    onSelect,
    handleAddNew,
    handleEdit,
    isLoginV2FlowEnabled,
    isMakeDefaultUxUpdateEnabled,
    defaultAddress,
    makeDefaultAddress,
    makeDefaultTextLabel,
    addressTextLabel,
    defaultTextLabel,
    isInternationalPhoneNumberEnabled,
  } = props;

  const carouselLength = addresses.length > 2;
  const carouselOptions = ADDRESS_CAROUSEL_CONSTANTS.CAROUSEL_OPTIONS;

  return (
    <>
      <Row fullBleed className={className}>
        <Col colSize={{ small: 6, medium: 8, large: 12 }} className="reg-shipping-header-container">
          <BodyCopy component="h3" className="reg-shipping-header">
            {renderLabel(
              addressSectionLabels?.lbl_addEditAddress_selectFromAddressBook,
              'lbl_addEditAddress_selectFromAddressBook'
            )}
          </BodyCopy>
          <Button
            buttonVariation="category-links-dark"
            dataLocator="addNewAddress"
            noLink
            onClick={handleAddNew}
            className="reg-shipping-edit-btn reg-shipping-parent-cta"
            aria-label={renderLabel(
              addressSectionLabels?.lbl_addEditAddress_addNew_btn,
              'lbl_addEditAddress_addNew_btn'
            )}
          >
            {renderLabel(
              addressSectionLabels?.lbl_addEditAddress_addNew_btn,
              'lbl_addEditAddress_addNew_btn'
            )}
          </Button>
        </Col>
        <Col colSize={{ small: 6, medium: 8, large: 12 }}>
          <BodyCopy component="div" className="address-list-container elem-pb-SM">
            <Carousel
              options={{
                ...carouselOptions,
                arrows: carouselLength,
              }}
              carouselConfig={{
                autoplay: false,
                variation: 'big-arrows',
                customArrowLeft: getIconPath('carousel-big-carrot'),
                customArrowRight: getIconPath('carousel-big-carrot'),
              }}
              isModule
              formName="ShippingForm"
            >
              {addresses &&
                addresses.map((address) => (
                  <AddressCard
                    key={address.addressId}
                    address={address}
                    disableEdit={disableEdit}
                    selectedAddressId={selectedValue}
                    onSelect={onSelect}
                    handleEdit={handleEdit}
                    editLabel={renderLabel(
                      getLabelFromCopyOrFromTranslation(
                        `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
                        GlobalActionsLabels
                      ),
                      'lbl_edit'
                    )}
                    isLoginV2FlowEnabled={isLoginV2FlowEnabled}
                    isMakeDefaultUxUpdateEnabled={isMakeDefaultUxUpdateEnabled}
                    defaultAddress={defaultAddress}
                    makeDefaultAddress={makeDefaultAddress}
                    makeDefaultTextLabel={makeDefaultTextLabel}
                    addressTextLabel={addressTextLabel}
                    defaultTextLabel={defaultTextLabel}
                    isInternationalPhoneNumberEnabled={isInternationalPhoneNumberEnabled}
                  />
                ))}
              <AddNewAddress
                handleAddNew={handleAddNew}
                addNewLabel={renderLabel(
                  addressSectionLabels?.lbl_addEditAddress_regAddNewAddress,
                  'lbl_addEditAddress_regAddNewAddress'
                )}
                isMakeDefaultUxUpdateEnabled={isMakeDefaultUxUpdateEnabled}
              />
            </Carousel>
          </BodyCopy>
        </Col>
      </Row>
    </>
  );
};

AddressCarousel.propTypes = {
  className: PropTypes.string,
  addresses: PropTypes.shape({}).isRequired,
  selectedValue: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  spcLabels: PropTypes.shape({}).isRequired,
  addressFormLabels: PropTypes.shape({}).isRequired,
  handleAddNew: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  labels: PropTypes.shape({}).isRequired,
};

AddressCarousel.defaultProps = {
  className: '',
  selectedValue: '',
};

export default withStyles(AddressCarousel, styles);
